import Dashboard, { DashboardLayout } from '.';
import MeetCouncil from 'src/ui/views/Dashboard/Tabs/MeetCouncil/MeetCouncil';


const MeetTheCouncilTab = ({ tab } = {
	tab: {
		text: 'Meet the council',
		content: <MeetCouncil />,
		requireWalletConnection: false,
	},
}) => <Dashboard selectedTab={tab} />;

MeetTheCouncilTab.Layout = DashboardLayout;

export default MeetTheCouncilTab;
